import React, { useState } from 'react';

import { motion } from 'framer-motion';

import { faqCategories } from '../data/faq-data';
import Accordion from './ui/Accordion';

interface FAQProps {
  className?: string;
}

const FAQ: React.FC<FAQProps> = ({ className = '' }) => {
  const [activeCategory, setActiveCategory] = useState<string>('general');

  // Cambiar categoría activa
  const handleCategoryChange = (category: string) => {
    setActiveCategory(category);
  };

  // Encontrar la categoría activa
  const activeCategoryData =
    faqCategories.find(cat => cat.title.toLowerCase() === activeCategory.toLowerCase()) ||
    faqCategories[0];

  return (
    <div className={`py-8 ${className}`}>
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Preguntas Frecuentes</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Encuentre respuestas a las preguntas más comunes sobre nuestros servicios, procesos y
            tecnologías.
          </p>
        </motion.div>

        {/* Navegación de categorías */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {faqCategories.map((category, index) => (
            <motion.button
              key={index}
              onClick={() => handleCategoryChange(category.title.toLowerCase())}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${activeCategory.toLowerCase() === category.title.toLowerCase() ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {category.title}
            </motion.button>
          ))}
        </div>

        {/* Preguntas de la categoría activa */}
        <motion.div
          key={activeCategory}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="space-y-4 max-w-4xl mx-auto"
        >
          {activeCategoryData.faqs.map((faq, index) => (
            <Accordion
              key={index}
              title={faq.question}
              id={`faq-${activeCategory}-${index}`}
              defaultOpen={index === 0}
              className="bg-white"
            >
              <p className="text-gray-600">{faq.answer}</p>
            </Accordion>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

// lint-disable-next-line react-refresh/only-export-components
export default FAQ;
